<template>
	<div>

		<h2 class="mb-5 cn-font grey--text">Detailansicht</h2>
		<!-- <p>
			In diesem Bereich stehen Ihnen verschiedene Werkzeuge zur vertiefenden Analyse Ihres Reifegrades zur Verfügung.</p>
			<ol>
				<li>Automatisch generierte Grafiken und Tabellen zu kumulierten Kennzahlen</li>
				
				<li>Benchmarking mit anderen Organisationen</li>
				<li>Exportfunktion aller Rohdaten zur externen vertiefenden Analyse</li>
			</ol> -->
		<v-alert class="mt-5" icon="mdi-file-excel-box" color="primary" border="left" colored-border>
			<a href="">Laden Sie Ihren Erhebungsdatensatz herunter</a>
		</v-alert>
	<v-row>
		<v-col cols="12" sm="3">
			<p class="cn-font">
				Datenserien
			</p>
			<div v-if="settings" class="mb-2">
				<v-item-group multiple v-model="series">
					<v-item v-slot:default="{ active, toggle }" v-for="s in ['Durchschnitt', 'Klinikum St. Annegret']" :value="s" :key="s">
						<v-chip class="mr-2 mb-2" @click="toggle" :color="active ? 'accent' : 'lightGrey'" dark>
							<v-icon small left>{{active ? 'mdi-check-circle' : 'mdi-circle'}}</v-icon>
							{{s}}
						</v-chip>
					</v-item>
				</v-item-group>
			</div>
			<p class="cn-font">
				Erhebungspunkte
			</p>
			<div class="mb-2">
				<v-item-group multiple v-model="labels">
					<div  v-for="part in themes" :key="part">
						<v-item v-slot:default="{ active, toggle }" :value="part" >
							<v-chip class="mr-2 mb-2" @click="toggle" :color="active ? 'primary' : 'lightGrey'" dark>
								<v-icon small left>{{active ? 'mdi-check-circle' : 'mdi-circle'}}</v-icon>
								Teil: {{part}}
							</v-chip>
						</v-item>
						<v-item v-slot:default="{ active, toggle }" v-for="section in sections[part] " :value="section" :key="section">
							<v-chip small class="mr-2 mb-2" @click="toggle" :color="active ? colors[3] : 'lightGrey'" dark>
								<v-icon small left>{{active ? 'mdi-check-circle' : 'mdi-circle'}}</v-icon>
								{{section}}
							</v-chip>
						</v-item>
					</div>
				</v-item-group>
			</div>
		</v-col>
		<v-col cols="12" sm="4" md="3">
			<SelectChartType class="ma-2" @click="(type) => {chart_type = type}"></SelectChartType>
			<v-text-field solo v-model="chart_title" label="Chart-Überschrift" class="ml-0 mr-0 mt-4"></v-text-field>
		</v-col>
		<v-col cols="12" sm="6"  md="6">		
			<v-card class="pa-4" style="position: relative; " v-if="chart_type">
				<h2 class="cn-font grey--text" v-if="chart_title">{{chart_title}}</h2>
				<v-component :options="options" :height="height" :is="chart_type" :chart-data="dataCollection"></v-component>
				<p class="text-right"><ResultsButtons></ResultsButtons>	</p>
			</v-card>	
			<v-card class="pa-4 mt-4">
				<ChartTable class="pa-2" :headers="headers" :rows="rows"></ChartTable>
				<p class="text-right"><ResultsButtons></ResultsButtons></p>
			</v-card>
		</v-col>
	</v-row>
	</div>
</template>

<style lang="less">
.v-list-item.active{
	background: #5568F1;

	.v-list-item__icon i, .v-list-item__title{
		color: white !important;
	}
}
.small {
	margin-top: 20px;
	max-width: 100%;
}

</style>
<script>

	import Vuex from "vuex"
	import ChartTable from "@/components/assessment/results/ChartTable"
	import SelectChartType from "@/components/assessment/results/SelectChartType"
	import ResultsButtons from "@/components/assessment/results/ResultsButtons"

	export default {
		name: "Analyse",
		components: {
			SelectChartType,
			ChartTable,
			ResultsButtons,
			BarChart: () => import( "@/assets/charts/BarChart.js" ),
			HBarChart: () => import( "@/assets/charts/HBarChart.js" ),
			LineChart: () => import( "@/assets/charts/LineChart.js" ),
			PieChart: () => import( "@/assets/charts/PieChart.js" ),
			AreaChart: () => import( "@/assets/charts/AreaChart.js" )
		},
		data () {
			return {
				chart_title: null,
				chart_type: null,
				data_collection: null,
				height: 250,
				themes: ["Struktur", "Prozess", "Ergebnis" ],
				labels: ["Struktur"],
				sections: {
					"Struktur": [
						"Strukturen der Sektorenübergreifende Vernetzung", 
						"Strukturen der Informationssicherheit / IT-Compliance",
					], 
					"Prozess": [
						"Prozesse der Medikationsverordnung mit Entscheidungsunterstützung",
					], 
					"Ergebnis": [
						"Ergebnisse im klinischen Anwendungsfeld",
						"Ergebnisse des Informationsmanagements",
						"Ergebnisse für die Organisation"
					] 
				},
				series: ["Durchschnitt", "Klinikum St. Annegret"], 
			}
		},
		mounted () {
			this.chart_type = "BarChart"
		},
		computed: {
			...Vuex.mapState({
				colors: state => state.colors,
				settings: state => state.assessmentSettings
			}),
			options() {
				if( this.chart_type == "PieChart" ){
					return {}
				}
				if( this.chart_type == "HBarChart" ){
					return {
						scales: {
						xAxes: [{
								display: true,
								ticks: {
									suggestedMax: 100,
									beginAtZero: true 
								}
							}]
						}
					}
				}
				return {
					scales: {
					yAxes: [{
							display: true,
							ticks: {
								suggestedMax: 100,
								beginAtZero: true 
							}
						}]
					}
				}
			},
			headers(){
				if( !this.dataCollection ){
					return [];
				}
				var h = this.dataCollection.datasets.map( d => d.label );
				return ["series"].concat(h);
			},
			rows(){
				if( !this.dataCollection ){
					return [];
				}
				var data = this.dataCollection;
				var rows = [];
				data.labels.forEach( l => {
					rows.push( {series: l } )
				})
				rows.forEach( (l, i) => {
					data.datasets.forEach( d => {
						l[d.label] = d.data[i]
					})
				})
				return rows;
			}, 
			dataCollection(){
				return this.fillData()
			}
		},
		methods: {
			fillData () {
				var self = this;
				var data_collection = {
					labels: self.labels,
					datasets: []
				}
				self.series.forEach( (s, i) => {
					var d = {
						label: s, 
						backgroundColor: self.colors[i], 
						data: []
					}
					self.labels.forEach( () => {
						var r = self.getRandomInt();
						d.data.push( r );
					})
					data_collection.datasets.push( d)
				} )

				return data_collection;
			},
			getRandomInt () {
				return Math.floor(Math.random() * 100 )
			}
		},
		watch: {
			settings: {
				deep: true,
				immediate: true,
				handler(newValue, oldValue ){
					if( newValue && !oldValue ){
						if( this.$store.hasModule("assessmentSettings")  ){
							this.$store.dispatch("assessmentSettings/getSettings").then( ( ) => {
							})
						}
						if( this.$store.hasModule("surveys")  ){
							this.$store.dispatch("surveys/getAll").then( ( ) => {
							})
						}
					}
					
				}
			}
		}
	}
	</script>

